import { FC, Fragment, SyntheticEvent, useCallback } from "react";
import { Divider, Image, Radio, Rating, Typography } from "theme";
import { Information } from "theme/icons";

import { Box, FormControl, FormControlLabel, FormGroup, Grid2 } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Hall } from "../../../../api/hooks/useHalls/type.ts";

export type SelectionRadioGroupProps = {
  name: string;
  options: Hall[];
  onChange: (value: string) => void;
  value?: string;
};

const StyledLink = styled("a")(() => {
  return {
    height: 18,
  };
});

const LabelWrapper: FC<{ option: Hall }> = ({ option }) => {
  return (
    <Grid2 width="100%" container justifyContent="space-between" alignItems="center">
      <Box>
        <Grid2 container columnGap={1.5}>
          <Image src={option.imageSmallUrl} />
          <Box>
            <Typography
              textTransform="uppercase"
              weight="semiBold"
              variant="body1"
              color="primary"
              mb={0.5}
            >
              {option.name}
            </Typography>
            <Typography
              textTransform="uppercase"
              weight="light"
              variant="body1"
              color="primary"
              mb={1.25}
            >
              {option.pricePerHour}грн/год
            </Typography>
            <Grid2 container columnGap={1.25} alignItems="center">
              <Rating value={option.votesCount} />
              <Typography variant="body2" color="primary">
                {option.commentsCount} відгук(ів)
              </Typography>
            </Grid2>
          </Box>
        </Grid2>
      </Box>
      <StyledLink
        href={`${import.meta.env.VITE_LANDING_WEBSITE}${option.information}`}
        target="_blank"
      >
        <Information />
      </StyledLink>
    </Grid2>
  );
};

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => {
  return {
    "&.MuiFormControlLabel-root": {
      display: "flex",
      margin: 0,
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      columnGap: theme.spacing(1.5),
      padding: theme.spacing(2.5, 0),
    },

    "&.MuiFormControlLabel-root.Mui-disabled": {
      opacity: 0.6,
    },

    "& .MuiFormControlLabel-label": {
      width: "100%",
    },
  };
});

const SelectionRadioGroup: FC<SelectionRadioGroupProps> = ({ onChange, options, name, value }) => {
  const handleChange = useCallback(
    (e: SyntheticEvent) => {
      const changedValue = (e.currentTarget as HTMLInputElement).value;

      onChange(changedValue);
    },
    [onChange],
  );

  return (
    <FormControl fullWidth>
      <FormGroup>
        {options.map((option, index) => {
          return (
            <Fragment key={option.id}>
              <Divider />
              <StyledFormControlLabel
                labelPlacement="start"
                name={name}
                value={String(option.id)}
                control={<Radio />}
                disabled={!option.isBookable}
                label={<LabelWrapper option={option} />}
                checked={value === String(option.id)}
                onChange={handleChange}
              />
              {index === options.length - 1 && <Divider />}
            </Fragment>
          );
        })}
      </FormGroup>
    </FormControl>
  );
};

export default styled(SelectionRadioGroup)(() => {
  return {};
});
